import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";
import { IPackage } from "../../../presentation/interfaces";

export class RemotePackage {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  async loadAll(): Promise<IPackage[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/public/all`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
